module.exports = __webpack_public_path__ + "img/imgs-item-2.9bc318de.png";